import { DefaultOptionType, FilterFunc } from 'rc-select/lib/Select';

export const normalizeSearchValue = (value: string) =>
	value.replace(/[\p{Dash_Punctuation}\u2212\uFE63\uFF0D]/gu, '').toLowerCase();

export const filterOption: FilterFunc<DefaultOptionType> = (input, option) => {
	return normalizeSearchValue(String(option?.label ?? '')).includes(normalizeSearchValue(input));
};
